import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=e5c229cc&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=js&"
export * from "./myList.vue?vue&type=script&lang=js&"
import style0 from "./myList.vue?vue&type=style&index=0&id=e5c229cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c229cc",
  null
  
)

export default component.exports